<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue';
import { IonApp, IonRouterOutlet } from '@ionic/vue';
import { useAppStore } from '@/stores/app.store';
import { usePrinterStore } from '@/stores/printer.store';
import { setI18nLocale, type SupportedLocale } from '@/app/i18n';

const appStore = useAppStore();
const printerStore = usePrinterStore();
let themeMedia: MediaQueryList | null = null;
let onThemeChange: ((e: MediaQueryListEvent) => void) | null = null;

onMounted(async () => {
  await appStore.hydrate();
  appStore.applyThemeClass();
  setI18nLocale(appStore.locale as SupportedLocale);
  // Restore any paired receipt printer (device-local pairing).
  void printerStore.hydrate();

  // React to OS theme changes while `theme = system`.
  if (typeof window !== 'undefined' && window.matchMedia) {
    themeMedia = window.matchMedia('(prefers-color-scheme: dark)');
    onThemeChange = () => {
      if (appStore.theme === 'system') appStore.applyThemeClass();
    };
    themeMedia.addEventListener('change', onThemeChange);
  }
});

onUnmounted(() => {
  if (themeMedia && onThemeChange) themeMedia.removeEventListener('change', onThemeChange);
});
</script>

<template>
  <ion-app>
    <ion-router-outlet />
  </ion-app>
</template>
